export default __webpack_public_path__ + "static/media/Revised Application Form & Criteria  for Resource Persons.d307ae24.docx";